import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { ReactSession } from 'react-client-session';
import { set, useForm } from 'react-hook-form';
import axios from 'axios';
import LoadingBar from 'react-top-loading-bar'
import { GoogleLogin } from 'react-google-login';
import { gapi } from 'gapi-script';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {Helmet} from "react-helmet";

import classes from './Register.module.css'
import GoogleLoginButton from '../Global/GoogleLoginButton';

function Register() {
  const navigate = useNavigate();
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [ifDisabled, setIfDisabled] = useState(false);
  const [progress, setProgress] = useState(100);

  ReactSession.setStoreType("localStorage");

  useEffect(() => {
    const logged_user = ReactSession.get("logged_user");
    logged_user && navigate("/profile");
  }, [])

  useEffect(() => {
    function start() {
      gapi.client.init({
        clientId: process.env.REACT_APP_GOOGLE_LOGIN_KEY,
        scope: 'email',
      });
    }

    gapi.load('client:auth2', start);
  }, []);

  const onSubmit = (data) => {
    // setIfDisabled(true);

    const toast_id = toast.loading("Please wait...");
    axios.post(`${process.env.REACT_APP_API_URL}/api/register.php`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }).then(res => {
      console.log(res.data);
      // toast.update(toast_id, {render: res.data.message, autoClose: 5000, type: res.data.status, isLoading: false});

      if(res.data.status === 'success') {
        navigate(`/verifyemail?m=${btoa(res.data.data.m)}&k=${btoa(res.data.data.k)}`);
      }

      // setIfDisabled(false);
    })
    .catch(err => {
      console.log(err);
    })
  }

  const onSuccess = response => {
    const data = new FormData();
    data.append("type", 'google');
    data.append("gid", response.profileObj.googleId);
    data.append("name", response.profileObj.name);
    data.append("email", response.profileObj.email);
    data.append("avatar", response.profileObj.imageUrl);
    data.append("ref", '');

    axios.post(`${process.env.REACT_APP_API_URL}/api/login.php`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then(res => {
      if(res.data.status === "success"){
        ReactSession.set("logged_user", res.data.data.id);
        ReactSession.set("message", res.data.data.message);
        ReactSession.set("group", res.data.data.group);
        ReactSession.set("name", res.data.data.name);
        ReactSession.set("username", res.data.data.username);
        ReactSession.set("avatar", res.data.data.avatar);

        navigate("/dashboard");
      }else {
        toast(res.data.message, {type: res.data.status, autoClose: 5000});
      }
    })
    .catch(err => {
      console.log(err);
    })
  };
  const onFailure = response => {
    console.log('FAILED', response);
  };

  return (
    <>
      <Helmet>
          <title>Wesharez Signup</title>
          <meta name="description" content="Share your web pages, articles, blog entries, photographs, and videos with friends, family, and the world on Wesharez." />
          <meta name="keywords" content="wesharez, youtube videos, musics, images, albums, earn money, Bookmarking, be a creator, share video, share your content, products, services, products and services, blog, latest articles, web pages, views, skin, science, days, review" />
      </Helmet>
      <LoadingBar
        color='#f11946'
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <ToastContainer />
      <div className={classes.registration_component}>
        <div className="container">
          <div className={classes.form_header}>
            <div className={classes.main_logo25} id="logo">
              <Link to='/'><img src={`${process.env.REACT_APP_API_URL}/storage/uploads/wesharez-pl-png5e9ace7d1bbda.png`} alt="Logo" /></Link>
            </div>
          </div>
          <div className={classes.registration_form}>
            <div className={`${classes.header} mb-4`}>
              <h3 className="text-center">Sign Up</h3>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="form-group mb-3">
                <label>Full Name</label>
                <input {...register("name", { required: true, maxLength: 10 })} className="form-control" type="text" placeholder="Full Name" />
                {errors.name && <p className={classes.error_msg}>Please Enter some value</p>}
              </div>
              <div className="form-group mb-3">
                <label>Email Address</label>
                <input
                  {...register("email", {
                    required: true,
                    pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                  })}
                  className="form-control"
                  type="email"
                  placeholder="Email Address"
                />
                {errors.email && <p className={classes.error_msg}>Please Enter valid email address</p>}
              </div>
              <div className="form-group mb-3">
                <label>Password</label>
                <input
                  {...register("password", {
                    required: true,
                    pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
                  })}
                  className="form-control"
                  type="password"
                  placeholder="Password"
                />
                {errors.password && <p className={classes.error_msg}>Password must be at least 8 characters, at least 1 letter and 1 number</p>}
              </div>
              <div className="form-group mb-3">
                <label>Repeat Password</label>
                <input
                  {...register("repeat_password", {
                    required: true,
                    pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/
                  })}
                  className="form-control"
                  type="password"
                  placeholder="Repeat password"
                />
                {errors.repeat_password && <p className={classes.error_msg}>Password must be at least 8 characters, at least 1 letter and 1 number</p>}
              </div>
              <div className="form-group mb-2 d-flex">
                  <input {...register('agree_to_terms', {required: true})} type="checkbox" className="form-check-input" id="exampleCheck1" />
                  <label className="form-check-label" htmlFor="exampleCheck1">&nbsp; By signing up, you agree to our <a href="terms_of_use.html">Terms of Use</a> and <a href="terms_of_use.html">Privacy Policy</a>.</label>
              </div>
              {errors.agree_to_terms && <p className={`${classes.error_msg} ${classes.terms_error}`}>Acceptance of terms and conditions is requried</p>}
              <div className="form-group mb-3 mt-3">
                <button className={`btn btn-primary btn-block ` + classes.register_btn} type="submit" disabled={ifDisabled}>Create Account</button>
              </div>
            </form>
            <div className={classes.google_login}>
                <span className="text-muted mt-4 mb-1 d-block">Or Sign in with social platforms</span>
                <GoogleLogin
                  clientId="572179960768-7273o50dvaj9sdnqr089fff3l5phjfkh.apps.googleusercontent.com"
                  render={renderProps => GoogleLoginButton(renderProps)}
                  onSuccess={onSuccess}
                  onFailure={onFailure}
                />
              </div>
            <p className="mb-0 mt-4">
              Already have an account? <Link to="/login">Log In</Link>
            </p>
          </div>
          <div className={classes.form_footer}>
            <img src="images/sign_logo.png" alt="" />© 2020{" "}
            <strong>Wesharez</strong>. All Rights Reserved.
          </div>
        </div>
      </div>
    </>
  )
}

export default Register